import React, { useEffect, useState } from 'react';

export enum ProductDetailsInjectorType {
    APPENDIX = 'appendix',
    WHY = 'why',
    CTA_BANNER = 'cta_banner'
}

interface IProductDetailsInjector {
    injectType: ProductDetailsInjectorType;
}

export const ProductDetailsInjector = ({ injectType }: IProductDetailsInjector) => {
    const [injectorTemplateContent, setInjectorTemplateContent] = useState('');
    const injectSelector = injectType && `pdp__${injectType}`;

    useEffect(() => {
        if (!injectSelector) { return null; }
        const template = document.getElementById(injectSelector);
        if (template) {
            setInjectorTemplateContent(template.innerHTML);
        }
      }, [injectSelector]);

    if (!injectSelector || !injectorTemplateContent?.trim().length) { return null; }

    window.dispatchEvent(
        new CustomEvent('teasersRendered', {
          detail: { sectionClass: injectSelector },
    }));

    return (
        <section className={injectSelector}>
            <div dangerouslySetInnerHTML={{ __html: injectorTemplateContent }} />
        </section>
    )
}
